import { getAuthHeaders } from "../utils/servicesUtils";
import { apiFetch } from "../utils/apiFetch";

export const getMyPolicyConsentStatus = async () => {
  const ENDPOINT = `/api/policy/me/status`;
  const pending = localStorage.getItem("pending_token");
  const headers = getAuthHeaders(pending || null);

  try {
    const response = await apiFetch(ENDPOINT, { headers }, { skipAuthHandling: true });
    const responseData = await response.json();
    if (!response.ok) throw responseData;
    return responseData;
  } catch (error) {
    console.error("Error in getMyPolicyConsentStatus:", error);
    if (error instanceof TypeError) {
      throw new Error("A connection error occurred while getMyPolicyConsentStatus.");
    }
    throw error;
  }
};

export const submitMyPolicyConsent = async (payload = {}) => {
  const ENDPOINT = `/api/policy/me/consent`;
  const pending = localStorage.getItem("pending_token");
  const headers = getAuthHeaders(pending || null);

  try {
    const response = await apiFetch(ENDPOINT, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    }, { skipAuthHandling: true });

    const responseData = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw responseData;
    }

    return responseData;
  } catch (error) {
    console.error("Error in submitMyPolicyConsent:", error);
    if (error instanceof TypeError) {
      throw new Error("A connection error occurred while submitMyPolicyConsent.");
    }
    throw error;
  }
};